// ./src/lib/FrameModel.js

const sFrame = Symbol('frame');

export default class FrameModel {
  constructor(frame) {
    this[sFrame] = frame;
  }

  /**
   * @returns {string} [image|video|audio]
   */
  get mediaType() {
    if (!this[sFrame].media) return 'image';

    const { file_type: fileType } = this[sFrame].media;

    if (!/^fl_(audio|video)$/.test(fileType)) return 'image';

    return fileType.split('_')[1];
  }

  get type() {
    // possible values:
    //  * loading
    //  * text-message
    //  * image-question
    //  * video-question

    const { frame_type: frameType } = this[sFrame];

    if (/^ft_(question|answer|cutscene)$/.test(frameType)) {
      return `${this.mediaType}-question`;
    }

    if (/^ft_message$/.test(frameType)) {
      return 'text-message';
    }

    return frameType.replace(/_/g, '-');
  }

  get selector() {
    return this[sFrame].selector;
  }

  get background() {
    if (!this[sFrame].background_image) return null;
    return this[sFrame].background_image.url;
  }

  get media() {
    if (!this[sFrame].media) return null;
    return this[sFrame].media.url;
  }

  get message() {
    return this[sFrame].message || 'No message';
  }

  get modifier() {
    return this[sFrame].modifier || '';
  }

  get rawType() {
    return this[sFrame].frame_type;
  }

  get roundNumber() {
    const { round } = this[sFrame];

    if (!round) return 0;

    return round.round_number;
  }

  get roundSelector() {
    const { round } = this[sFrame];

    if (!round) return null;

    return round.selector;
  }

  get isBetRound() {
    const { round } = this[sFrame];

    if (!round) return false;

    return !!round.bet_params;
  }

  get roundType() {
    const { round } = this[sFrame];

    if (!round) return null;

    return round.round_type;
  }

  get questionInfo() {
    if (this[sFrame].frame_type !== 'ft_question'
      && this[sFrame].frame_type !== 'ft_cutscene') return {};

    return {
      roundNumber: this[sFrame].round.round_number,
      questionNumber: this[sFrame].question_number,
      questionCount: this[sFrame].questions_count,
    };
  }

  getFrameData() {
    return {
      background: this.background,
      media: this.media,
      message: this.message,
      modifier: this.modifier,
    };
  }

  getFrameMeta() {
    if (this[sFrame].meta) return this[sFrame].meta;
    return {};
  }

  toString() {
    return JSON.stringify(this[sFrame]).replace(/,/g, ', ');
  }
}
